export const StatusBadge = ({ status, type = 'tag', label: customLabel }) => {
  const styles = {
    tag: {
      ativa: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
      atribuida: 'bg-blue-50 text-blue-700 border border-blue-200',
      armazem: 'bg-slate-100 text-slate-700 border border-slate-200',
      inativa: 'bg-red-50 text-red-700 border border-red-200'
    },
    incident: {
      pendente: 'bg-amber-50 text-amber-700 border border-amber-200',
      resolvida: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
      ignorada: 'bg-slate-100 text-slate-700 border border-slate-200',
      em_progresso: 'bg-blue-50 text-blue-700 border border-blue-200',
      default: 'bg-slate-100 text-slate-700 border border-slate-200'
    }
  };

  const labels = {
    tag: {
      ativa: 'Ativa',
      atribuida: 'Atribuída',
      armazem: 'Armazém',
      inativa: 'Inativa'
    },
    incident: {
      pendente: 'Pendente',
      resolvida: 'Resolvida',
      ignorada: 'Ignorada',
      em_progresso: 'Em Progresso'
    }
  };

  const style = styles[type]?.[status] || styles[type]?.default || styles.tag.armazem;
  const label = customLabel || labels[type]?.[status] || status;

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${style}`} data-testid={`status-badge-${status}`}>
      {label}
    </span>
  );
};
